// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"80b5feb7","229":"aab68157","254":"a4e59c86","262":"4a9cd31f","266":"121eca03","341":"169c65a2","381":"13b04cd1","641":"eae36126","973":"636c0305"}[chunkId] + ".chunk.css";
};